"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the result of multiplying the given double-double by -4.
 * @param q low order double
 * @param Q hight order double
 */
function qMultByNeg4([q, Q]) {
    return [-4 * q, -4 * Q];
}
exports.qMultByNeg4 = qMultByNeg4;
//# sourceMappingURL=q-mult-by-neg-4.js.map